'use client'

import React from 'react'
import Link from 'next/link'
import Follow from '@/components/Shared/Follow'
import { Company } from '@/types/company'
import styles from './styles.module.scss'

interface CompanySquareCardProps {
  company: Company
}

export default function CompanySquareCard({ company }: CompanySquareCardProps) {
  return (
    <article className={styles.squareCard}>
      <Link href={`/${company.openUrl}`} className={styles.cardImgLink} target='_blank'>
        <div className={styles.companyLogo}>
          <div className={styles.dummyImageArea} />
          <img
            src={company.imageUrl}
            width={50}
            height={50}
            className={styles.logoImage}
            alt={company.name}
            loading='lazy'
          />
        </div>
        <span className={styles.squareCardName}>{company.name}</span>
      </Link>
      <div className={styles.cardContents}>{company.info}</div>
      <div className={styles.followButton}>
        <Follow followText='フォロー' card type='company' item={company} />
      </div>
    </article>
  )
}
